<div id="save-pdf" class="card">
  <div class="card-body">
    <div class="">
      <div class="">
        <img id="logo" class="login-img" src="assets/images/logohori.png" />
        <h5 class="">Transacción exitosa</h5>
        <h6 class="card-subtitle mb-2 text-muted">Su transacción ha sido procesada exitosamente</h6>
      </div>
    </div>
    <ul class="list-group">
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Monto</span>
        <span>{{comprobante?.monto | currency}}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Documento</span>
        <span>{{comprobante?.documento }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Cuenta Origen</span>
        <span>{{comprobante?.numeroCuentaOrigen}}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Cuenta Destino</span>
        <span>{{comprobante?.numeroCuentaDestino}}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Beneficiario</span>
        <span>{{comprobante?.beneficiario}}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Fecha Actual</span>
        <span>{{fecha}}</span>
      </li>
    </ul>
  </div>
</div>
